window.addEventListener('DOMContentLoaded', () => {

    $('.variable-width').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true
    });

    const triger = document.querySelector('.internet__more'),
          internetCardNone = document.querySelectorAll('.internet__card--none');

    triger.addEventListener('click', () => {
        internetCardNone.forEach(item => {
            item.style.display = 'block';
        });
        triger.style.display = 'none';
    });

});
